declare const  RemoteId: any;

function properties() {
    try {
        return RemoteId && RemoteId.FrontEnd.Properties;
    } catch(e) {
        return {};
    }
}

export const environment = {
    production: properties().production || false,
    backendBaseUrl: properties().backendBaseUrl || 'https://remoteidcertisign-homolog.com.br/api',
    varejoHost: properties().varejoHost || 'remoteidcertisign-homolog.com.br',
    recaptchaSiteKey: properties().recaptchaSiteKey || '6LfSt2QUAAAAADwO0ZP-evSXQ3ZSi2jmU_EoI4oS',
    whitelist: properties().whitelist || ['remoteidcertisign-homolog.com.br'],
    revokeFenaconUrl: properties().revokeFenaconUrl || 'https://homologacao.fenaconcd.com.br:8443/sitefenaconcd/revogar-certificado',
    local: false
};
